import Devices from '@propertypal/shared/src/resources/images/mmw/MMW-devices.png';
import { MILLAR_MCCALL_WYLIE, MILLAR_MCCALL_WYLIE_TRANSPARENT } from '@propertypal/shared/src/styles/theme';
import styled, { css } from 'styled-components';

export const WideContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${MILLAR_MCCALL_WYLIE_TRANSPARENT};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  grid-column: span 2;
  padding: 15px 45px;
  color: ${({ theme }) => theme.textDark};
  align-items: center;

  h2 {
    font-size: 44px;
    line-height: 44px;
    margin: 15px 0;
  }

  b,
  span {
    color: ${MILLAR_MCCALL_WYLIE};
  }
`;

export const AdText = styled.p`
  font-weight: 600;
  margin: 15px 0;
  font-size: 24px;
  max-width: 250px;
`;

export const DeviceImages = styled.div<{ $small?: boolean }>`
  position: relative;
  background-image: url(${Devices.src});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${({ $small }) =>
    $small
      ? css`
          width: 100%;
          height: 230px;

          svg {
            position: absolute;
            transform: rotate(90deg);
            right: -5px;
            top: -20px;
            height: 50px;
          }
        `
      : css`
          flex: 0 0 50%;
          height: 100%;

          svg {
            position: absolute;
            left: -25px;
            top: -120px;
            bottom: 0;
            margin: auto;
          }
        `}
`;

export const Container = styled.div`
  background-color: ${MILLAR_MCCALL_WYLIE_TRANSPARENT};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 15px;
  color: ${({ theme }) => theme.textDark};
  text-align: center;

  h2 {
    font-size: 34px;
    line-height: 34px;
  }

  p {
    font-weight: 600;
    margin: 15px 0;
  }

  b,
  span {
    color: ${MILLAR_MCCALL_WYLIE};
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
`;
